<template>
  <div>
  </div>
</template>
<script>
import axios from "axios"
import authority from '../authority'
import { jwt } from '../mixin/jwt'

export default {
  name: 'KeycloakPage',
  mixins: [jwt],
  props: ['realms'],
  data () {
    return {
      code: '',
      message: ''
    }
  },
  beforeMount(){
      if(!this.$cognito.isUseCognito){
        if(this.$route.query.code){
          this.code = this.$route.query.code
          axios.post("/api/keycloak_token/",{
            code: this.code,
            hospitalCode: this.realms
          }).then(response => {
            var accessToken = this.parseJwt(response.data.data.token.accessToken)
            this.$store.commit('auth',{
                isLogIn: true,
                realms: this.realms,
                accessToken: response.data.data.token.accessToken,
                idToken: response.data.data.token.idToken,
                refreshToken: response.data.data.token.refreshToken,
                privilege: Number(accessToken.privilege) || 1 
              })
            if(authority.notLogin.indexOf(Number(accessToken.privilege)) !== -1){
              this.$router.replace('/' + this.realms + '/login')
            } else {
              this.$router.replace('/' + this.realms + '/common/user/index')
            }
          }).catch(err => {
            this.message = err.message
            this.$router.replace('/' + this.realms + '/login')
          })
        }        
      }
  }
}
</script>
